/**
 * Generated by orval v6.29.0 🍺
 * Do not edit manually.
 * Cloudsaver.Resources.Host.Api
 * OpenAPI spec version: 1.0
 */

export type BaseResourceTaggabilityItem = typeof BaseResourceTaggabilityItem[keyof typeof BaseResourceTaggabilityItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseResourceTaggabilityItem = {
  None: 'None',
  Taggable: 'Taggable',
  Labelable: 'Labelable',
  DelegatedTaggable: 'DelegatedTaggable',
  DelegatedLabelable: 'DelegatedLabelable',
} as const;
